<template>
  <div class="product-create">
    <el-card shadow="hover">
      <template slot="header">
        <div class="card-header">
          <span>创建商品</span>
        </div>
      </template>
      
      <el-form :model="productForm" :rules="rules" ref="productForm" label-width="120px">
        <el-form-item label="商品名称" prop="name">
          <el-input v-model="productForm.name" placeholder="请输入商品名称" style="width: 400px;"></el-input>
        </el-form-item>
        
        <el-form-item label="商品分类" prop="category">
          <el-select v-model="productForm.category" placeholder="请选择商品分类" style="width: 400px;">
            <el-option label="随心订" value="随心订"></el-option>
            <el-option label="下午茶" value="下午茶"></el-option>
            <el-option label="小食" value="小食"></el-option>
            <el-option label="饮品" value="饮品"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="商品价格" prop="price">
          <el-input-number v-model="productForm.price" :min="0" :precision="2" placeholder="请输入商品价格" style="width: 400px;"></el-input-number>
          <span style="margin-left: 10px;">元</span>
        </el-form-item>
        
        <el-form-item label="库存数量" prop="stock">
          <el-input-number v-model="productForm.stock" :min="0" placeholder="请输入库存数量" style="width: 400px;"></el-input-number>
          <span style="margin-left: 10px;">件</span>
        </el-form-item>
        
        <el-form-item label="商品描述" prop="description">
          <el-input type="textarea" v-model="productForm.description" :rows="4" placeholder="请输入商品描述" style="width: 400px;"></el-input>
        </el-form-item>
        
        <el-form-item label="商品图片">
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :on-change="handleImageChange"
            :auto-upload="false">
            <img v-if="productForm.imageUrl" :src="productForm.imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="submitForm">创建商品</el-button>
          <el-button @click="resetForm">重置</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ProductCreate',
  data() {
    return {
      productForm: {
        name: '',
        category: '随心订',
        price: 0,
        stock: 0,
        description: '',
        imageUrl: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '请选择商品分类', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入商品价格', trigger: 'blur' }
        ],
        stock: [
          { required: true, message: '请输入库存数量', trigger: 'blur' }
        ],
        description: [
          { max: 500, message: '描述不能超过 500 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleImageChange(file) {
      const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
        return;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return;
      }
      
      const reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = (e) => {
        this.productForm.imageUrl = e.target.result;
      };
    },
    submitForm() {
      this.$refs.productForm.validate((valid) => {
        if (valid) {
          this.$message.success('商品创建成功！');
          console.log('商品信息:', this.productForm);
          setTimeout(() => {
            this.$router.push('/products');
          }, 1000);
        } else {
          this.$message.error('请填写完整的商品信息');
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.productForm.resetFields();
      this.productForm.imageUrl = '';
    },
    goBack() {
      this.$router.push('/products');
    }
  }
}
</script>

<style scoped>
.product-create {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.avatar-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader >>> .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: cover;
}
</style>
